import * as React from "react";
const SvgFiRrBoothCurtain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-booth-curtain_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v15c0 2.206 1.794 4 4 4h5c2.206 0 4-1.794 4-4V9.194c1.996 3.46 5.069 5.204 7.257 6.05-1.661 1.396-3.715 3.627-4.225 6.43-.104.567.052 1.15.426 1.599.385.461.949.726 1.55.726h1.912c2.288 0 4.08-1.757 4.08-4V5c0-2.757-2.243-5-5-5M5 2h6v10H2V5c0-1.654 1.346-3 3-3m4 20H4c-1.103 0-2-.897-2-2v-6h9v6c0 1.103-.897 2-2 2m4.027-20h2.014c.195 3.065 1.289 5.561 3.277 7.418a.997.997 0 0 0 1.413-.047 1 1 0 0 0-.048-1.413C18.109 6.487 17.224 4.485 17.04 2h1.961c1.654 0 3 1.346 3 3v8.759c-2.557-.711-8.537-3.274-8.974-11.759M22 20c0 1.122-.914 2-2.08 2l-1.921.034c.448-2.457 2.531-4.474 4.001-5.625zM9 17a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-booth-curtain_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoothCurtain;
